import Api from '../http/ApiService'

class StoreService {
  static stores = () =>
    Api.get('/stores')
      .then(response => response.data)
}

export default StoreService